<template>
  <SettingsSection>
    <SettingsSectionTitle> Donations </SettingsSectionTitle>

    <SettingsSubsection>
      <form
        class="flex flex-col space-y-4"
        @submit="onSubmit"
      >
        <div class="grid grid-cols-2 gap-2">
          <template
            v-for="(_, index) in new Array(6).fill(
              undefined
            )"
            :key="index"
          >
            <FormInputPrice
              :name="`button${index + 1}Amount`"
              :label="`Button ${index + 1} Amount`"
            />
          </template>
        </div>
        <FormInputText
          label="Thank You Message"
          name="thankYouMessage"
        />

        <FormInputSelect
          label="Thank You Icon"
          :options="thankYouIconOptions"
          name="thankYouIcon"
          disable-null
        />

        <div class="col-span-4 flex justify-end">
          <FormSubmitButton> Save </FormSubmitButton>
        </div>
      </form>
      <template v-if="isSubmitting">
        <div class="bg-background-fg/8 absolute inset-0">
        </div>
      </template>
    </SettingsSubsection>
  </SettingsSection>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { donationThankyouIcons } from "@/services/settings/donationSettings"

const donationSettingsFormSchema = z.object({
  button1Amount: z.number().int(),
  button2Amount: z.number().int(),
  button3Amount: z.number().int(),
  button4Amount: z.number().int(),
  button5Amount: z.number().int(),
  button6Amount: z.number().int(),
  thankYouMessage: z.string(),
  thankYouIcon: z.enum(
    assertIsNonEmptyArray(donationThankyouIcons)
  ),
})

const { data: donationSettings } = useDonationSettings()

const thankYouIconOptions = Object.entries(
  DONATION_THANK_YOU_ICONS
).map(([key, { icon, label }]) => ({
  value: key,
  label: label,
  icon: icon,
}))
const { handleSubmit, setValues } = useForm({
  validationSchema: toTypedSchema(
    donationSettingsFormSchema
  ),
})

whenever(
  () => donationSettings.value,
  (values) => {
    setValues(values)
  },
  {
    deep: true,
    immediate: true,
  }
)

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (params) => {
  isSubmitting.value = true
  try {
    await partialUpdateDonationSettings(params)
    toast.success("Donation settings updated")
  } catch (error) {
    toast.error("Failed to update donation settings")
    logError(error)
  } finally {
    isSubmitting.value = false
  }
})
</script>
